/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum GetChallengesSort {
    CREATEDAT = 'CREATED_AT',
    NAME = 'NAME'
}

export function GetChallengesSortFromJSON(json: any): GetChallengesSort {
    return GetChallengesSortFromJSONTyped(json, false);
}

export function GetChallengesSortFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengesSort {
    return json as GetChallengesSort;
}

export function GetChallengesSortToJSON(value?: GetChallengesSort | null): any {
    return value as any;
}

